import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {User} from '../../../models/user';
import {ReplaySubject, Subject} from 'rxjs';
import {FormControl} from '@angular/forms';
import {MonitorUserTimeline} from '../../../models/monitor-user-timeline';
import {UserTimeLinePoint} from '../../../models/user-time-line-point';
import {Market} from '../../../models/market';
import {MarketLevel} from '../../../models/market-level';
import {DatePipe} from '@angular/common';
import {DaterangepickerDirective, LocaleConfig} from 'ngx-daterangepicker-material';
import {MatPaginator, MatSort} from '@angular/material';
import {BaseDatasourceService} from '../../../services/base-datasource.service';
import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import {ActivatedRoute} from '@angular/router';
import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import {Title} from '@angular/platform-browser';
import {TitleBroadcastService} from '../../../services/title-broadcast.service';
import {debounceTime} from 'rxjs/operators';
import {takeUntil} from 'rxjs/internal/operators';
import swal from 'sweetalert2';
import {Endpoints} from '../../../config/endpoints';
import {base_urls} from '../../../config/base_urls';

@Component({
    selector: 'app-monitoring-user-timeline-by-date-range',
    templateUrl: './monitoring-user-timeline-by-date-range.component.html',
    styleUrls: ['./monitoring-user-timeline-by-date-range.component.scss']
})
export class MonitoringUserTimelineByDateRangeComponent implements OnInit {

    lat = 23.8383283;
    lng = 90.3759853;

    loggedUser: User;
    userList: User[] = [];
    filteredUserList: ReplaySubject<User[]> = new ReplaySubject<User[]>(1);
    userFilter: FormControl = new FormControl();
    timelineList: MonitorUserTimeline[] = [];
    filteredTimelineList: MonitorUserTimeline[] = [];
    listDataSource: UserTimeLinePoint[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];
    displayedColumns = ['SN', 'From', 'To', 'Address', 'Duration', 'Distance'];

    market = new Market();
    user = new User();
    headers = [];
    headerValues = [];
    exportData = [];
    progress: number;
    showProgressBar = false;
    waitForProgress = true;
    totalPages = 0;
    selectedTab = 'Map';
    lineColors: string[] = ['mediumseagreen', 'deepskyblue', 'gray', 'navy', 'yellow', 'orange', 'purple', 'cyan', 'magenta', 'lime'];
    imeiList: any[] = [];
    selectedImei: string;
    isCalenderOpen = false;
    tabList = ['Map', 'Timeline'];

    @ViewChild(DaterangepickerDirective) dateRangePicker: DaterangepickerDirective;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    dataSource: BaseDatasourceService<MonitorUserTimeline>;

    filters = {
        'userId': null,
        'fromDate': moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        'toDate': moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        fileType: null
    };
    userType = 'ORGANIZATION_USER';
    fromDate = moment();
    toDate = moment();
    moment = moment;
    calendarLocale: LocaleConfig;
    ranges: any;
    selectedRange: any = {startDate: null, endDate: null};
    datePipe = new DatePipe('en-US');
    private _unsubscribeAll: Subject<any>;

    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.getLocationList();
        }
    }

    constructor(private route: ActivatedRoute, private service: BaseService, private auth: AuthService, private titleService: Title, private titleBroadcastService: TitleBroadcastService) {
        this._unsubscribeAll = new Subject();
        this.titleBroadcastService.title.next('User Timeline By Date Range');
        this.loggedUser = auth.user;
        this.marketLevels = this.loggedUser.MarketLevelHierarchy;
        this.marketLevels.forEach(marketLevel => {
            this.markets[marketLevel.Rank] = [];
            this.selectedMarket[marketLevel.Rank] = null;
        });

        this.calendarLocale = {
            customRangeLabel: 'Pick a date...',
            applyLabel: 'Apply',
            cancelLabel: 'Clear',
            format: 'DD-MMM-YYYY',
            daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 1
        };

        this.ranges = {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [
                moment().subtract(1, 'month').startOf('month'),
                moment().subtract(1, 'month').endOf('month'),
            ],
        };

        this.selectedRange.startDate = moment().subtract(0, 'days').startOf('day');
        this.selectedRange.endDate = moment().subtract(0, 'days').startOf('day');
    }

    ngOnInit(): void {
        this.titleService.setTitle('Monitoring Team Tracking');
        this._getUserList();
        this.userFilter.valueChanges.pipe(debounceTime(500), takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.userList) {
                return;
            }

            const search = this.userFilter.value;
            if (!search) {
                this.filteredUserList.next(this.userList.slice());
                return;
            }

            this._getUserList(search);
            this.filteredUserList.next(this.userList.filter(user => user.UserName.toLowerCase().indexOf(search.toLowerCase()) > -1
            ));
        });
    }

    dateChangeListener(pEvent: any): void {
        this.filters.fromDate = this.datePipe.transform(this.selectedRange.startDate, 'yyyy-MM-dd');
        this.filters.toDate = this.datePipe.transform(this.selectedRange.endDate, 'yyyy-MM-dd');
        this.isCalenderOpen = false;
    }

    _getUserList(search?: string): void {
        let marketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                marketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }

        this.service.getUserList({
            ResponseSize: 'MINIFY',
            UserType: this.userType,
            MarketIdList: marketIdList,
            SearchKey: search,
            PageNumber: 0,
            RecordsPerPage: 50
        }).subscribe(userList => {
            this.userList = userList;
            this.filteredUserList.next(this.userList.slice());
        });
    }

    openPicker(): void {
        this.isCalenderOpen = !this.isCalenderOpen;
        if (this.isCalenderOpen) {
            this.dateRangePicker.open();
        } else {
            this.dateRangePicker.hide();
        }
    }

    getLocationList(): void {
        if (!this.filters.userId) {
            swal('Error!', 'Please select a user', 'error');
            return;
        }

        this.loadingData = true;
        this.service.getMonitorUserTimelineByDateRange(this.filters, base_urls.hrws).subscribe(locationList => {
            this.loadingData = false;
            if (locationList.length > 0) {
                this.timelineList = locationList;
                this.filteredTimelineList = locationList;
                this.lat = locationList[0].timeLinePoints[0].latitude;
                this.lng = locationList[0].timeLinePoints[0].longitude;
                this.listDataSource = locationList.map(pItem => pItem.timeLinePoints).reduce((acc, points) => acc.concat(points), []);
                this.imeiList = locationList.map(pItem => ({Imei: pItem.imei, Device: pItem.deviceName}));
            } else {
                this.timelineList = [];
                this.filteredTimelineList = [];
                this.imeiList = [];
            }
        }, error => {
            this.loadingData = false;
        });
    }

    imeiChangeListener(): void {
        if (this.selectedImei) {
            this.filteredTimelineList = this.timelineList.filter(pItem => pItem.imei == this.selectedImei);
        } else {
            this.filteredTimelineList = this.timelineList;
        }
        this.listDataSource = this.filteredTimelineList.map(pItem => pItem.timeLinePoints).reduce((acc, points) => acc.concat(points), []);
    }

    tabChangeListener(pTab: string): void {
        if (pTab == 'Map') {
            this.selectedTab = 'Map';
        } else {
            this.selectedTab = 'Timeline';
        }
    }

    downloadReport(): void {
        let isSelected: boolean;
        let isSelected1: boolean;
        let fileName: string;
        let fileType: string;
        swal({
            title: 'Download Report',
            html:
                '<div class="example-container"><mat-form-field><input matInput id="report" placeholder="Enter report name"' +
                '></mat-form-field><br><br>' +
                '<div class="container">\n' +
                '<div class="col-md-12">' +
                '<input class="col-xs-3" type="radio" value="CSV" id="input1" name="filetype" checked> CSV' +
                '<input class="col-xs-4 col-xs-offset-4" name="filetype" type="radio" value="XLSX" id="input2" style="margin-left: 20px;"> XLSX ' +
                '</div>\n' +
                '</div><div>',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Download',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                swal.disableConfirmButton();
                isSelected = (<HTMLInputElement>document.getElementById('input1')).checked;

                isSelected1 = (<HTMLInputElement>document.getElementById('input2')).checked;
                if (isSelected || isSelected1) {
                    swal.enableConfirmButton();
                } else {
                    swal.disableConfirmButton();
                }
                fileName = (<HTMLInputElement>document.getElementById('report')).value;
                if (isSelected) {
                    fileType = (<HTMLInputElement>document.getElementById('input1')).value;
                } else if (isSelected1) {
                    fileType = (<HTMLInputElement>document.getElementById('input2')).value;
                }
                this.filters.fileType = fileType;
                this.service.generateAsyncGetUrlForMicroservice(base_urls.hrws + Endpoints.export_monitor_user_timeline_date_range, this.filters, fileName, true).subscribe(
                    data => {
                        swal('Message', data.message, 'success');

                    });
            },

            allowOutsideClick: () => !swal.isLoading()
        });
    }

}
